/* Mailvorlagen für Anfragen – werden im CRM erzeugt und zum Kopieren angezeigt.
   Hochzeit (bzw. Service "hochzeits-dj") → "ihr", sonst "du".
   Hier kannst du die Texte jederzeit anpassen. */

// Link zu deinem Terminbuchungs-Tool (z. B. Calendly, Cal.com, Google-Terminplan). Leer lassen = Text ohne Link.
export const VIDEOCALL_LINK = 'https://calendly.com/happybeats/30min';

// Link, über den Kunden eine Google-Rezension schreiben können
export const BEWERTUNG_LINK = 'https://g.page/r/CeIv96KTwF-1EBM/review';

export const SERVICE_LABEL = {
  'hochzeits-dj': 'Hochzeits-DJ',
  dj: 'DJ',
  livemusik: 'Livemusik',
  anfrage: 'Startseite'
};

export const WOCHENTAGE = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

export function datumLang(iso) {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return `${WOCHENTAGE[d.getDay()]}, ${m[3]}.${m[2]}.${m[1]}`;
}

export function datumKurz(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
  return m ? `${m[3]}.${m[2]}.${m[1]}` : (iso || '');
}

export function istIhr(a) {
  return a.service === 'hochzeits-dj' || /hochzeit|trauung/i.test(a.eventart || '');
}

// "eure Hochzeit", "deinen Geburtstag", "euer Jubiläum" …
function anlass(a, ihr) {
  const e = (a.eventart || '').toLowerCase();
  const w = (genus) => (ihr ? { f: 'eure', m: 'euren', n: 'euer' } : { f: 'deine', m: 'deinen', n: 'dein' })[genus];
  if (a.service === 'hochzeits-dj' || e.includes('hochzeit')) return `${w('f')} Hochzeit`;
  if (e.includes('trauung')) return `${w('f')} Trauung`;
  if (e.includes('geburtstag')) return `${w('m')} Geburtstag`;
  if (e.includes('firmen')) return `${w('f')} Firmenfeier`;
  if (e.includes('weihnacht')) return `${w('f')} Weihnachtsfeier`;
  if (e.includes('jubil')) return `${w('n')} Jubiläum`;
  if (e.includes('sommer')) return `${w('n')} Sommerfest`;
  if (e.includes('gartenfeier') || e.includes('party')) return `${w('f')} Feier`;
  return `${w('f')} Feier`;
}

const leistung = (a) => (a.service === 'livemusik' ? 'mit Livemusik zu begleiten' : 'musikalisch zu begleiten');
const gruss = 'Viele Grüße\nMarkus\n\nHappybeats · Markus Holder\nhappybeats.de · +49 7031 2090492\nDatenschutz: happybeats.de/datenschutz.html';

function videocallSatz(ihr) {
  if (VIDEOCALL_LINK) {
    return ihr
      ? `Hier könnt ihr euch direkt einen passenden Termin aussuchen:\n${VIDEOCALL_LINK}`
      : `Hier kannst du dir direkt einen passenden Termin aussuchen:\n${VIDEOCALL_LINK}`;
  }
  return ihr
    ? 'Schreibt mir gern zwei, drei Zeitfenster, die euch passen – dann melde ich mich mit einem Termin.'
    : 'Schreib mir gern zwei, drei Zeitfenster, die dir passen – dann melde ich mich mit einem Termin.';
}

// Antwort-Vorlagen auf eine neue Anfrage
export const ANTWORT_VORLAGEN = [
  { id: 'videocall', label: 'Termin frei – Videocall' },
  { id: 'angebot', label: 'Termin frei – Angebot folgt' },
  { id: 'belegt', label: 'Termin belegt' },
  { id: 'rueckfrage', label: 'Datum fehlt – Rückfrage' }
];

export function antwortMail(vorlage, a) {
  const ihr = istIhr(a);
  const name = a.vorname || '';
  const datum = datumLang(a.datum) || '[Datum]';
  const an = anlass(a, ihr);
  const betreff = {
    videocall: `Eure Anfrage für den ${datumKurz(a.datum)}`,
    angebot: `Eure Anfrage für den ${datumKurz(a.datum)}`,
    belegt: `Eure Anfrage für den ${datumKurz(a.datum)}`,
    rueckfrage: 'Deine Anfrage bei Happybeats'
  }[vorlage];
  const subject = ihr ? betreff.replace('Deine Anfrage', 'Eure Anfrage') : betreff.replace('Eure Anfrage', 'Deine Anfrage');

  const start = ihr
    ? `Hallo ${name},\n\nvielen Dank für eure Anfrage und euer Interesse an Happybeats.`
    : `Hallo ${name},\n\nvielen Dank für deine Anfrage und dein Interesse an Happybeats.`;
  const frei = `Ich habe am ${datum} noch Zeit und würde mich sehr freuen, ${an} ${leistung(a)}.`;

  let mitte = '';
  if (vorlage === 'videocall') {
    mitte = ihr
      ? `${frei}\n\nBevor wir alles Weitere besprechen, würde ich vorschlagen, dass wir einen kurzen Videocall machen. So können wir uns kurz kennenlernen und in Ruhe darüber sprechen, wie ihr euch euren Tag vorstellt und was euch wichtig ist.\n\n${videocallSatz(true)}\n\nIch freue mich auf euch!`
      : `${frei}\n\nBevor wir alles Weitere besprechen, würde ich vorschlagen, dass wir einen kurzen Videocall machen. So können wir uns kurz kennenlernen und in Ruhe darüber sprechen, wie du dir deine Feier vorstellst und was dir wichtig ist.\n\n${videocallSatz(false)}\n\nIch freue mich auf dich!`;
  } else if (vorlage === 'angebot') {
    mitte = ihr
      ? `${frei}\n\nIch schicke euch demnächst ein unverbindliches Angebot mit allen Infos. Wenn ihr noch Fragen habt oder etwas besprechen möchtet, meldet euch einfach bei mir.`
      : `${frei}\n\nIch schicke dir demnächst ein unverbindliches Angebot mit allen Infos. Wenn du noch Fragen hast oder etwas besprechen möchtest, melde dich einfach bei mir.`;
  } else if (vorlage === 'belegt') {
    mitte = ihr
      ? `Leider bin ich am ${datum} schon gebucht und kann ${an} deshalb nicht begleiten. Schade, dass es nicht klappt.\n\nIch wünsche euch eine wunderschöne Feier und alles Gute für eure Hochzeit!`
      : `Leider bin ich am ${datum} schon gebucht und kann ${an} deshalb nicht begleiten. Schade, dass es nicht klappt.\n\nIch wünsche dir eine tolle Feier und ganz viel Spaß!`;
  } else if (vorlage === 'rueckfrage') {
    mitte = ihr
      ? `Damit ich schauen kann, ob ich an eurem Wunschtermin noch Zeit habe, schickt mir bitte noch kurz das Datum und den Ort, an dem ihr ${an} plant.\n\nDann kann ich euch direkt Bescheid geben.`
      : `Damit ich schauen kann, ob ich an deinem Wunschtermin noch Zeit habe, schick mir bitte noch kurz das Datum und den Ort, an dem du ${an} planst.\n\nDann kann ich dir direkt Bescheid geben.`;
  }
  return { subject, body: `${start}\n\n${mitte}\n\n${gruss}` };
}

export function angebotMail(a) {
  const ihr = istIhr(a);
  const name = a.vorname || '';
  const datum = datumLang(a.datum) || '[Datum]';
  return ihr
    ? {
      subject: `Angebot für ${anlass(a, true)} am ${datumKurz(a.datum)}`,
      body: `Hallo ${name},\n\nanbei schicke ich euch mein Angebot für ${anlass(a, true)} am ${datum}.\n\nWenn ihr noch Fragen habt oder etwas besprechen möchtet, meldet euch einfach bei mir.\n\nWenn alles für euch passt, gebt mir kurz Bescheid. Dann schicke ich euch den Booking-Vertrag und wir machen den Termin fest.\n\nIch würde mich sehr freuen, euch an eurem Tag zu begleiten!\n\n${gruss}`
    }
    : {
      subject: `Angebot für dein Event am ${datumKurz(a.datum)}`,
      body: `Hallo ${name},\n\nanbei schicke ich dir mein Angebot für dein Event am ${datum}.\n\nWenn du noch Fragen hast oder etwas besprechen möchtest, melde dich einfach bei mir.\n\nWenn alles für dich passt, gib mir kurz Bescheid. Dann schicke ich dir den Booking-Vertrag und wir machen den Termin fest.\n\nIch würde mich sehr freuen, dein Event zu begleiten!\n\n${gruss}`
    };
}

export function vertragMail(a) {
  const ihr = istIhr(a);
  const name = a.vorname || '';
  return {
    subject: `Booking-Vertrag für den ${datumKurz(a.datum)}`,
    body: ihr
      ? `Hallo ${name},\n\nsuper, ich freue mich sehr, dass ich ${anlass(a, true)} begleiten darf!\n\nIm Anhang findet ihr den Booking-Vertrag. Bitte schickt ihn mir ausgefüllt und unterschrieben zurück, damit ich ihn ebenfalls unterschreiben kann.\n\nErgänzend gelten meine AGB:\nhttps://happybeats.de/agb.html\n\nDie Rechnung über die Anzahlung von 30 % bekommt ihr separat.\n\nWenn noch etwas unklar ist, meldet euch einfach bei mir.\n\nIch freue mich auf euch!\n\n${gruss}`
      : `Hallo ${name},\n\nsuper, ich freue mich sehr, dass ich dein Event begleiten darf!\n\nIm Anhang findest du den Booking-Vertrag. Bitte schick ihn mir ausgefüllt und unterschrieben zurück, damit ich ihn ebenfalls unterschreiben kann.\n\nErgänzend gelten meine AGB:\nhttps://happybeats.de/agb.html\n\nDie Rechnung über die Anzahlung von 30 % bekommst du separat.\n\nWenn noch etwas unklar ist, melde dich einfach bei mir.\n\nIch freue mich auf dein Event!\n\n${gruss}`
  };
}

// Danke-Mail nach dem Event mit Bitte um Google-Rezension
export function dankeMail(a) {
  const ihr = istIhr(a);
  const name = a.vorname || '';
  return ihr
    ? {
      subject: 'Vielen Dank',
      body: `Hallo ${name},\n\nvielen Dank nochmal für die tolle Feier, es hat mir richtig Spaß gemacht, für euch und eure Gäste Musik zu machen.\n\nWenn ihr mit mir und meiner Musik zufrieden wart, würde ich mich sehr über eine kurze Bewertung bei Google freuen. Ein paar persönliche Worte reichen völlig und helfen mir wirklich sehr:\n\n${BEWERTUNG_LINK}\n\nIch wünsche euch beiden alles Gute für eure gemeinsame Zukunft!\n\n${gruss}`
    }
    : {
      subject: 'Danke für die tolle Feier',
      body: `Hallo ${name},\n\nvielen Dank nochmal für die tolle Feier, es hat mir richtig Spaß gemacht, für dich und deine Gäste Musik zu machen.\n\nWenn du mit mir und meiner Musik zufrieden warst, würde ich mich sehr über eine kurze Bewertung bei Google freuen. Ein paar persönliche Worte reichen völlig und helfen mir wirklich sehr:\n\n${BEWERTUNG_LINK}\n\nIch wünsche dir alles Gute und vielleicht sieht man sich ja mal wieder!\n\n${gruss}`
    };
}
